import { ScreenType } from '@ui-system/interfaces-screen';
import { pleaseImplement } from '@ui-system/utils';

const Screen = pleaseImplement<ScreenType>('Screen');

export default Screen;
